import React from "react";

import { useSelector } from "react-redux";

import { Link } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from "../../components/panel/panel.jsx";

import TableReact from "../../components/table/Table";
import _ from "lodash";
import saveExcel from "../../helper/ExportToXslx";

import { formatDateTime, formatMoney } from "../../helper/formatter.js";

const columnsXls = [
    { header: "ID", key: "id" },
    { header: "Registro", key: "registro" },
    { header: "Razon Social", key: "razonsocial" },
    { header: "Nit", key: "nit" },
    { header: "Direccion", key: "direccion" },
    { header: "Giro", key: "giro" },
    { header: "Categoria", key: "categoria" },
];

const Terceros = () => {
    const terceros = useSelector((state) => state.tercero.items);
    const comprobantes = useSelector((state) => state.comprobante.items);

    let comprobantesByTercero = _(comprobantes)
        .reject("anulado")
        .reject("cancelado")
        .groupBy("terceroId")
        .mapValues((comprobantes) => {
            return _.sumBy(comprobantes, "pendiente");
        })
        .value();

    const columns = React.useMemo(
        () => [
            {
                Header: "NRC",
                accessor: "registro",
                canGroupBy: false,
                Cell: ({ row }) => <div className="text-nowrap">{row.original?.registro}</div>,
            },
            {
                Header: "RAZON SOCIAL",
                accessor: "razonsocial",
                Cell: ({ row }) => (
                    <Link to={"/tercero/" + row.original?.id} className="fw-bold text-nowrap">
                        {row.original?.razonsocial}
                    </Link>
                ),
                canGroupBy: false,
            },
            {
                Header: "NIT",
                accessor: "nit",
                canGroupBy: false,
                Cell: ({ row }) => <div className="text-nowrap">{row.original?.nit}</div>,
            },
            {
                id: "tipo",
                Header: "Tipo de tercero",
                accessor: (row) => {
                    return (row.is_cliente ? "cliente " : " ") + (row.is_proveedor ? "proveedor " : "");
                },
                canGroupBy: false,
                Cell: ({ row }) => {
                    return (
                        <>
                            {row.original?.is_cliente ? (
                                <span className="badge bg-green me-1 text-uppercase">cliente</span>
                            ) : (
                                <></>
                            )}
                            {row.original?.is_proveedor ? (
                                <span className="badge bg-indigo text-uppercase">proveedor</span>
                            ) : (
                                <></>
                            )}
                        </>
                    );
                },
            },
            {
                id: "saldo_pendiente",
                Header: "Saldo pendiente",
                accessor: (row) => {
                    return formatMoney(comprobantesByTercero[row.id], "0.00");
                },
                Cell: ({ row }) => <div className="text-nowrap">{formatMoney(row.values.saldo_pendiente)}</div>,
                canGroupBy: false,
            },
            {
                Header: "Ult. Modificacion",
                accessor: "updatedAt",
                Cell: ({ row }) => <div className="text-nowrap">{formatDateTime(row.original?.updatedAt)}</div>,
                canGroupBy: false,
            },
        ],
        []
    );

    const data = React.useMemo(() => _.values(terceros), [terceros]);
    return (
        <Panel>
            <PanelHeader>Listado de terceros registrados</PanelHeader>
            <PanelBody>
                <div className="d-flex flex-wrap">
                    <Link type="button" className="btn btn-green me-1 mb-1" to={"/tercero"}>
                        <i className="fa fa-plus fa-fw"></i> Agregar nuevo tercero
                    </Link>
                    <button
                        type="button"
                        className="btn btn-indigo me-1 mb-1"
                        onClick={() => saveExcel("Terceros", columnsXls, data)}>
                        <i className="fa fa-file-excel fa-fw"></i> Exportar
                    </button>
                </div>
            </PanelBody>
            <TableReact columns={columns} data={data} selection={false} />
        </Panel>
    );
};

export default Terceros;
